import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/shuffle.vue
var o = {
	name: "DtIconShuffle",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--shuffle"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Shuffle",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M1.647 1.647a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1-.707.707l-2.5-2.5a.5.5 0 0 1 0-.707Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		d: "M7.5 1.5A.5.5 0 0 1 8 1h2.5a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V2.707l-7.646 7.647a.5.5 0 0 1-.707-.707L9.293 2H8a.5.5 0 0 1-.5-.5Zm3 6a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H8a.5.5 0 1 1 0-1h1.293L7.147 7.854a.5.5 0 0 1 .707-.707L10 9.293V8a.5.5 0 0 1 .5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=shuffle.js.map